import React from 'react';
import ReactLink from '@client/components/reactLink/ReactLink';
import hlfLogo from '@client/shared/images/HLF_Stor_logga.svg';
import Image from '@client/components/image/Image';
import styles from './logo.scss';

export const Logo = () => (
  <ReactLink className={styles.link} to={'/'}>
    <Image src={hlfLogo} className={styles.logo} />
  </ReactLink>
);
